<app-navbar>
    <section content>
        <router-outlet></router-outlet>
    </section>
</app-navbar>